module.exports = __webpack_public_path__ + "img/code.7d58da12.png";